import Axios from 'axios';

export * as request from './requests';

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

const axios = Axios.create( {
  baseURL: BASE_URL,
  timeout: 1000,
  headers: { 'X-Custom-Header': 'foobar' },
} );


export default axios;
